var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var End = function (_a) {
    var _b;
    var execution = _a.execution, executeNodeOnUserInteraction = _a.executeNodeOnUserInteraction;
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "chat__messages-group" }, { children: _jsx("div", __assign({ className: "chat__messages-list" }, { children: _jsx("div", __assign({ className: "chat__messages-list-item" }, { children: _jsx("div", __assign({ className: "chat__messages-bubble chat__message-type-TEXT" }, { children: _jsx("span", __assign({ className: "actual" }, { children: (_b = execution.node.data.formData) === null || _b === void 0 ? void 0 : _b.action })) })) })) })) })) }));
};
export default End;
